const overwrites = {
  filled: {
    bg: "base.d100",
    boxShadow: "lg",

    _hover: {
      bg: "base.900",
    },

    _focus: {
      borderColor: "none",
      bg: "base.800",
      boxShadow: "none",
    },
  },

  outlined: {
    borderWidth: 3,
    borderColor: "base.800",
    bg: "base.d100",

    _hover: {
      borderColor: "base.700",
    },

    _focus: {
      borderColor: "base.500",
      bg: "base.900",
      boxShadow: "none",
    },
  },
}

const inputs = {
  Input: {
    variants: {
      filled: {
        field: {
          ...overwrites.filled,
        },
      },

      outline: {
        field: {
          ...overwrites.outlined,
        },
      },
    },
  },

  Textarea: {
    variants: {
      outline: {
        height: "100%",
        ...overwrites.outlined,
        scrollbarWidth: "thin",
        "::-webkit-scrollbar": {
          width: "5px",
        },
        "::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: "primary.200",
          borderRadius: "10px",
        },
      },
    },
  },

  Select: {
    variants: {
      outline: {
        field: {
          ...overwrites.outlined,
          "> option": {
            background: "primary.d700",
          },
        },
      },
    },
  },
}

export default inputs
